var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.72894 3.06195C5.08875 2.70214 5.57675 2.5 6.0856 2.5H10.9693C11.1081 2.5 11.2412 2.55513 11.3393 2.65326L16.223 7.53698C16.3212 7.63511 16.3763 7.7682 16.3763 7.90698V15.5814C16.3763 16.0902 16.1742 16.5782 15.8143 16.9381C15.4545 17.2979 14.9665 17.5 14.4577 17.5H6.0856C5.57675 17.5 5.08875 17.2979 4.72894 16.9381C4.36913 16.5782 4.16699 16.0902 4.16699 15.5814V4.4186C4.16699 3.90976 4.36913 3.42175 4.72894 3.06195ZM6.0856 3.54651C5.8543 3.54651 5.63248 3.63839 5.46893 3.80194C5.30538 3.96549 5.2135 4.18731 5.2135 4.4186V15.5814C5.2135 15.8127 5.30538 16.0345 5.46893 16.1981C5.63248 16.3616 5.8543 16.4535 6.0856 16.4535H14.4577C14.689 16.4535 14.9108 16.3616 15.0744 16.1981C15.2379 16.0345 15.3298 15.8127 15.3298 15.5814V8.43023H10.9693C10.6803 8.43023 10.4461 8.19596 10.4461 7.90698L10.4461 3.54651H6.0856ZM11.4926 4.28651L14.5898 7.38372H11.4926L11.4926 4.28651Z",
  fill: "#00538F"
});

function SvgFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.2a3d25e8.svg";
export { ForwardRef as ReactComponent };